import type { StateContext } from '@ngxs/store';
import { ZoomSliderMode } from 'commons';
import { produce } from 'immer';
import { GenerateEChartConfig } from '../actions';
import type { MultiViewStateModel } from '../MultiViewStateModel';
import { getViewIndex } from '.';

/**
 * Handles global zoom mode configuration by resetting the zoom state
 * to a single global entry. Mutates the draft view directly.
 */
export function handleGlobalZoomMode(view: any, currentZoomState: any) {
  // Derive the broadest date range from all lane zoom states
  const startValues = currentZoomState.map((z: any) => z.startValue).filter((v: any) => v !== undefined && v !== null);
  const endValues = currentZoomState.map((z: any) => z.endValue).filter((v: any) => v !== undefined && v !== null);

  view.zoomState = [
    {
      axis: ['0'],
      start: 0,
      end: 100,
      dataZoomId: 'zoom_0',
      startValue: startValues.length > 0 ? Math.min(...startValues) : undefined,
      endValue: endValues.length > 0 ? Math.max(...endValues) : undefined,
    },
  ];
}

/**
 * Handles lane zoom mode configuration
 */
export function handleLaneZoomMode(view: any, currentZoomState: any) {
  view.zoomState = view.lanes.map((_l: any, i: number) => {
    return {
      axis: [String(i)],
      start: 0,
      end: 100,
      dataZoomId: `zoom_${i}_${i}`,
      startValue: currentZoomState[0]?.startValue,
      endValue: currentZoomState[0]?.endValue,
    };
  });
}

/**
 * Sets the zoom slider mode and updates the zoom state accordingly
 */
export function setZoomSliderMode(ctx: StateContext<MultiViewStateModel>, zoomSliderMode: ZoomSliderMode) {
  ctx.setState(
    produce(ctx.getState(), (draft) => {
      const view = draft.views[getViewIndex(ctx)];
      view.zoomSliderMode = zoomSliderMode;
      const currentZoomState = view.zoomState;

      switch (zoomSliderMode) {
        case ZoomSliderMode.GLOBAL:
          handleGlobalZoomMode(view, currentZoomState);
          break;
        case ZoomSliderMode.LANE:
          handleLaneZoomMode(view, currentZoomState);
          break;
        default:
          return;
      }
    })
  );
  ctx.dispatch(GenerateEChartConfig);
}
